import React from 'react';
import PropTypes from 'prop-types';
import CustomStep from 'workOrderComponents/close/CustomStep';
import TextFormatter from 'utils/TextFormatter';
import EquipmentUtils from 'utils/EquipmentUtils';
import SqcOutletDisplay from 'equipmentComponents/SqcOutletDisplay';

class SqcCloseStep extends React.Component {

    componentDidMount() {
        const { equipmentDetails, sqcActions, orderId, orderToSqc } = this.props;

        if (orderToSqc) {

            const outletsToSqc = EquipmentUtils.getSqcableEquipment(equipmentDetails);

            outletsToSqc.forEach((outlet) => {

                const macAddress = TextFormatter.formatMacAddress(outlet.get('macAddress'));

                const request = {
                    'macaddress': macAddress
                };

                if (macAddress) {
                    sqcActions.sqcGenerateLoadStarted(request, orderId);
                }

            });
        }

    }

    render() {
        const {
            workOrderActions,
            orderCloseDetails,
            orderId,
            stepConfig,
            equipmentDetails,
            sqcActions,
            sqcResults
        } = this.props;

        const stepValidation = orderCloseDetails.getIn(['stepValidation']);
        const activeStep = orderCloseDetails.get('currentStep');

        const outletsToSqc = EquipmentUtils.getSqcableEquipment(equipmentDetails);

        const sqcDisplay = [];

        let bypassMessage = '';

        if (sqcResults && sqcResults.get('bypassBecauseOfFailure')) {
            bypassMessage = 'There was an error getting the modem levels. Bypassing SQC Check.';
        }

        outletsToSqc.forEach((outlet, index) => {

            sqcDisplay.push((
                <div key={'outlet_sqc_' + index}>

                    <SqcOutletDisplay
                        showMacAddessOnButton={true}
                        sqcActions={sqcActions}
                        sqcResults={sqcResults}
                        orderId={orderId}
                        outlet={outlet} />
                    <br />

                </div>
            ));
        });

        let label = 'Service Quality Check';

        if (stepValidation.getIn(['sqc', 'isWarning'])) {
            label = `Service Quality Check - ${stepValidation.getIn(['sqc', 'message'])}`;
        }

        if (outletsToSqc.count() === 0) {
            bypassMessage = 'No equipment found to SQC.';
        }

        return (

            <CustomStep
                onStepClick={workOrderActions.setCloseStep}
                label={label}
                stepConfig={stepConfig}
                stepConfigKey="sqcStepConfig"
                orderCloseDetails={orderCloseDetails}
                activeStep={activeStep}
                orderId={orderId}
                stepValidation={stepValidation}
                stepKey="sqc">
                <div style={{
                    paddingLeft: '8px'
                }}>
                    {bypassMessage}
                    <br /> {sqcDisplay}
                </div>

            </CustomStep>

        );

    }
}

SqcCloseStep.propTypes = {
    workOrderActions: PropTypes.object,
    sqcResults: PropTypes.object,
    sqcActions: PropTypes.object,
    orderCloseDetails: PropTypes.object,
    orderId: PropTypes.string,
    stepConfig: PropTypes.object,
    equipmentDetails: PropTypes.object
};

export default SqcCloseStep;


// WEBPACK FOOTER //
// ./src/components/equipment/SqcCloseStep.js